import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content"]

  async open(event) {
    const link = event.currentTarget
    const bookId = link.dataset.bookId
    const copiesCount = parseInt(link.dataset.copiesCount || "0", 10)

    if (copiesCount === 0 || !bookId) return

    event.preventDefault()

    this.modalTarget.classList.remove("hidden")
    this.contentTarget.innerHTML = '<div class="p-8 text-center text-beige-500 font-fira text-sm">Loading copies…</div>'
    document.body.style.overflow = "hidden"

    try {
      const response = await fetch(`/app/books/${bookId}/copies`, {
        headers: { "Accept": "text/html" }
      })
      if (response.ok) {
        this.contentTarget.innerHTML = await response.text()
      } else {
        this.contentTarget.innerHTML = '<div class="p-8 text-center text-red-600 font-fira text-sm">Failed to load copies.</div>'
      }
    } catch (e) {
      this.contentTarget.innerHTML = '<div class="p-8 text-center text-red-600 font-fira text-sm">Failed to load copies.</div>'
    }
  }

  close(event) {
    if (event && event.target !== this.modalTarget && !event.currentTarget.dataset.action?.includes("close")) return
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.modalTarget.classList.add("hidden")
      document.body.style.overflow = ""
    }
  }

  async unmark(event) {
    if (!confirm("Detach this copy from the group?")) return

    const url = event.currentTarget.dataset.url
    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      }
    })

    if (response.ok) {
      window.location.reload()
    }
  }
}
